import { HeartBank } from "../../../managers/HeartBank.ts";
import { Crypto } from "../../../models/Crypto.ts";
import template from "./hb-ship.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";
import {
    getHero,
    loadYouTube,
    defaults,
    pickFile,
    isIOS,
    parseYouTubeUrl
} from "../../global.ts";
import { Media, OPFSResult } from "../../../managers/Media.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbMain } from "../hb-main.ts";
import { Stamps } from "../../../models/Stamps.ts";

type Jewelry = {
    s: string; // service
    n: string; // name (youtube) or file name
    d?: string; // directory
    f?: string; // encrypted folder
    i?: string; // trove doc id OR youtube video id
    l?: string; // link
    e?: string; // encrypted link
};
// random links can be put inside message
// now: upload 2x times for each item: can be costly // more flexible for user
// TODO: later more cost effective: user decides upfront if cloud or local => permanent choice ?
// logged out still see same items; okay for now: LATER: when log out => clear all items ??

export class HbShip extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private media = new Media();
    private stamps = new Stamps();
    private crypto: Crypto = new Crypto();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain; // for checkin spinner

    private ship: HTMLElement;
    private stamp: HTMLButtonElement;
    private form: HTMLFormElement;
    private name: HTMLInputElement;

    private checkinForm: HTMLElement;
    private checkin: SVGElement;
    private checkinLabel: HTMLSpanElement; // deprecated
    private checkinCheckbox: HTMLInputElement;
    private checkinLocation: HTMLSpanElement;
    private checkinIcon: SVGElement;

    private checkinCrews: HTMLSelectElement;
    private checkinOrgs: HTMLSelectElement;
    private checkinReset: HTMLButtonElement;
    //private cachedLocation = ""; // redundant

    private diamondTotal: HTMLSpanElement;
    private diamondIcon: SVGElement;
    //private scanIcon: SVGElement;
    //private cloudIcon: SVGElement;
    //private codeIcon: SVGElement;
    //private crystalIcon: SVGElement;

    private cloud: HTMLButtonElement;
    private code: HTMLButtonElement;
    private crystal: HTMLButtonElement;

    //private storage: HTMLElement;
    //private storageCheckbox: HTMLInputElement;
    //private storageName: HTMLInputElement;
    private storageFootnote: HTMLParagraphElement;

    private diamond: HTMLElement; // context
    private diamondImport: HTMLButtonElement;
    private diamondUpload: HTMLButtonElement;
    private diamondTrove: HTMLButtonElement; // TODO: later
    private diamondLabel: HTMLSpanElement;
    private diamondCheckbox: HTMLInputElement;

    private diamonds: HTMLUListElement;
    private diamondURL: HTMLInputElement;
    private diamondAdd: HTMLButtonElement;

    private dialog: HTMLDialogElement;
    private dialogProgress: HTMLElement;
    private dialogPhoto: HTMLButtonElement;
    private dialogCamera: HTMLButtonElement;
    private dialogVideo: HTMLButtonElement;
    private dialogCamcorder: HTMLButtonElement;
    private dialogAudio: HTMLButtonElement;
    private dialogMicrophone: HTMLButtonElement;
    private dialogCancel: HTMLButtonElement;
    private dialogClose: HTMLButtonElement;
    private dialogAiPicture: HTMLButtonElement;
    private dialogAiShort: HTMLButtonElement;
    private dialogAiSong: HTMLButtonElement;

    private timelock: HTMLElement;
    private clock: HTMLElement;
    private date: HTMLInputElement;
    private time: HTMLInputElement;

    private trove: Jewelry[] = []; //JSON.parse(localStorage.getItem("trove") || "[]");

    private readonly errorMessage =
        "You already used this name. Please choose another.";

    constructor() {
        super();
        render(template(null), this);

        this.ship = this.querySelector("#hb-ship")!;
        this.stamp = this.querySelector("#hb-ship-stamp")!;
        this.form = this.querySelector("#hb-ship-form")!;
        this.name = this.querySelector("#hb-ship-name")!;

        this.checkinForm = this.querySelector("#hb-ship-checkin-form")!;
        this.checkin = this.querySelector("#hb-ship-checkin")!;
        this.checkinLabel = this.querySelector("#hb-ship-checkin-label")!;
        this.checkinCheckbox = this.querySelector("#hb-ship-checkin-checkbox")!;
        this.checkinLocation = this.querySelector("#hb-ship-checkin-location")!;
        this.checkinIcon = this.querySelector("#hb-ship-checkin-icon")!;

        this.checkinCrews = this.querySelector("#hb-ship-checkin-crews")!;
        this.checkinOrgs = this.querySelector("#hb-ship-checkin-orgs")!;
        this.checkinReset = this.querySelector("#hb-ship-checkin-reset")!;

        this.diamond = this.querySelector("#hb-ship-diamond")!;
        this.diamondImport = this.querySelector("#hb-ship-diamond-import")!;
        this.diamondUpload = this.querySelector("#hb-ship-diamond-upload")!;
        this.diamondTrove = this.querySelector("#hb-ship-diamond-trove")!;
        this.diamondLabel = this.querySelector("#hb-ship-diamond-label")!;
        this.diamondCheckbox = this.querySelector("#hb-ship-diamond-checkbox")!;

        this.diamonds = this.querySelector("#hb-ship-diamonds")!;
        this.diamondURL = this.querySelector("#hb-ship-diamond-url")!;
        this.diamondAdd = this.querySelector("#hb-ship-diamond-add")!;

        this.cloud = this.querySelector("#hb-ship-storage-cloud")!;
        this.code = this.querySelector("#hb-ship-storage-code")!;
        this.crystal = this.querySelector("#hb-ship-storage-crystal")!;

        this.diamondTotal = this.querySelector("#hb-ship-diamond-total")!;
        this.diamondIcon = this.querySelector("#hb-ship-storage-diamond-icon")!;
        //this.scanIcon = this.querySelector("#hb-ship-storage-scan-icon")!;
        //this.cloudIcon = this.querySelector("#hb-ship-storage-cloud-icon")!;
        //this.codeIcon = this.querySelector("#hb-ship-storage-code-icon")!;
        //this.crystalIcon = this.querySelector("#hb-ship-storage-crystal-icon")!;

        //this.storageCheckbox = this.querySelector("#hb-ship-storage-checkbox")!;
        //this.storageName = this.querySelector("#hb-ship-storage-name")!;
        this.storageFootnote = this.querySelector("#hb-ship-storage-footnote")!;

        this.dialog = this.querySelector("#hb-ship-dialog")!;
        this.dialogProgress = this.querySelector("#hb-ship-dialog-progress")!;
        this.dialogPhoto = this.querySelector("#hb-ship-dialog-photo")!;
        this.dialogCamera = this.querySelector("#hb-ship-dialog-camera")!;
        this.dialogVideo = this.querySelector("#hb-ship-dialog-video")!;
        this.dialogCamcorder = this.querySelector("#hb-ship-dialog-camcorder")!;
        this.dialogAudio = this.querySelector("#hb-ship-dialog-audio")!;
        this.dialogMicrophone = this.querySelector(
            "#hb-ship-dialog-microphone"
        )!;
        this.dialogCancel = this.querySelector("#hb-ship-dialog-cancel")!;
        this.dialogClose = this.querySelector("#hb-ship-dialog-close")!;
        this.dialogAiPicture = this.querySelector(
            "#hb-ship-dialog-ai-picture"
        )!;
        this.dialogAiShort = this.querySelector("#hb-ship-dialog-ai-short")!;
        this.dialogAiSong = this.querySelector("#hb-ship-dialog-ai-song")!;

        this.timelock = this.querySelector("#hb-ship-timelock")!;
        this.clock = this.querySelector("#hb-ship-clock")!;
        this.date = this.querySelector("#hb-ship-date")!;
        this.time = this.querySelector("#hb-ship-time")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-ship",
            override: true
        };

        this.modal = new Modal(this.ship, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.addCheckinListeners();
        this.addStorageListeners();
        this.addDiamondListeners();
        this.addDialogListeners();
        this.form.addEventListener("submit", this.submit.bind(this));

        this.date.addEventListener("focus", () => {
            setTimeout(() => {
                // this.clock.classList.toggle("fill-gray-500", !this.date.value);
                // this.clock.classList.toggle("fill-red-500", !!this.date.value);
                // const localDate =
                //     this.toLocalDateFromStrings(
                //         this.date.value,
                //         this.time.value
                //     ) || new Date();
                // console.log(localDate?.toString());
                // const utcDate = new Date(localDate.getTime());
                // console.log(utcDate.toUTCString());

                const timelock = this.toLocalDateFromStrings(
                    this.date.value,
                    this.time.value
                );
                localStorage.setItem(
                    "timelock",
                    timelock ? timelock.getTime().toString() : ""
                );
                this.renderTimeLock();
            }, 100);
        });
        this.time.addEventListener("change", () => {
            const timelock = this.toLocalDateFromStrings(
                this.date.value,
                this.time.value
            );
            if (timelock) {
                localStorage.setItem("timelock", timelock.getTime().toString());
                this.renderTimeLock();
            }
        });
        this.time.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") event.preventDefault();
        });

        this.heartbank.addAuthStateListener((user) => {
            // set default storage
            const storage = localStorage.getItem("storage");
            if (user?.phoneNumber) {
                if (!storage) localStorage.setItem("storage", "cloud"); // pro not needed bc always set before login: keep just in case user clear cache
            } else {
                if (!storage) localStorage.setItem("storage", "code");
                if (storage === "cloud")
                    localStorage.setItem("storage", "crystal"); // bc data might be too big
            }

            render(template(user), this);
            this.render(user);
        });
    }

    private getKind() {
        const kind = this.querySelector<HTMLInputElement>(
            "input[name=hb-ship-checkin]:checked"
        );
        return kind?.value;
    }

    private addCheckinListeners() {
        this.checkinCheckbox.addEventListener("change", () => {
            this.checkinIcon.style.fill = this.checkinCheckbox.checked
                ? "silver"
                : "orange";
            // this.checkinLabel.textContent = this.checkinCheckbox.checked
            //     ? "Private"
            //     : "Public";
        });

        this.checkin.addEventListener("click", async () => {
            // if (this.cachedLocation !== window.earth.cachedLocation) {
            //     await this.renderCheckin(true);
            //     this.cachedLocation = window.earth.cachedLocation;
            // }
            this.checkinForm.classList.toggle("hidden");
        });

        this.checkinReset.addEventListener(
            "click",
            async () => await this.renderCheckin(true)
        );

        ["click", "change"].forEach((event) => {
            this.checkinCrews.addEventListener(event, () => {
                const radio = this.querySelector(
                    "input[value=crew]"
                ) as HTMLInputElement;
                radio.checked = true;
                this.checkinLocation.textContent =
                    this.checkinCrews.options[
                        this.checkinCrews.selectedIndex
                    ].text;
            });
        });

        ["click", "change"].forEach((event) => {
            this.checkinOrgs.addEventListener(event, () => {
                const radio = this.querySelector(
                    "input[value=org]"
                ) as HTMLInputElement;
                radio.checked = true;
                this.checkinLocation.textContent =
                    this.checkinOrgs.options[
                        this.checkinOrgs.selectedIndex
                    ].text;
            });
        });

        this.querySelectorAll<HTMLInputElement>(
            "input[name=hb-ship-checkin]"
        ).forEach((radio) => {
            radio.addEventListener("change", () => {
                const event = new Event("change", { bubbles: false });
                if (this.getKind() === "crew")
                    this.checkinCrews.dispatchEvent(event);
                else this.checkinOrgs.dispatchEvent(event);
            });
        });
    }

    private addStorageListeners() {
        this.stamp.addEventListener("click", () => {
            if (
                confirm(
                    "Are you sure you want to un-link the B-Stamp you scanned?"
                )
            ) {
                localStorage.removeItem("stamp");
                this.renderStamp();
            }
        });

        this.cloud.addEventListener(
            "click",
            this.setStorage.bind(this, "cloud")
        );

        this.code.addEventListener("click", this.setStorage.bind(this, "code"));

        this.crystal.addEventListener(
            "click",
            this.setStorage.bind(this, "crystal")
        );

        // this.storageCheckbox.addEventListener("change", () => {
        //     this.storageName.required = this.storageCheckbox.checked;
        //     this.storageName.classList.toggle(
        //         "hidden",
        //         !this.storageCheckbox.checked
        //     );
        //     localStorage.setItem(
        //         "isStored",
        //         this.storageCheckbox.checked.toString()
        //     );
        // });
    }

    private addDiamondListeners() {
        this.diamondCheckbox.addEventListener("change", () => {
            this.diamondIcon.style.fill = this.diamondCheckbox.checked
                ? "silver"
                : "skyblue";
            // this.diamondLabel.textContent = this.diamondCheckbox.checked
            //     ? "Private"
            //     : "Public";
        });

        this.diamondIcon.addEventListener("click", () => {
            this.renderDiamondBtns();
            this.diamond.classList.toggle("hidden");
        });

        this.diamondImport.addEventListener("click", () => {
            this.dialog.showModal();
        });

        this.diamondUpload.addEventListener("click", () => {
            this.dialog.showModal();
        });

        // TODO: later copy jewelry link from Trove or download as local file
        this.diamondTrove.addEventListener("click", () => {
            alert("HeartBank® Trove coming soon!");
        });

        this.diamondURL.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.processYouTube(this.diamondURL.value.trim());
            }
        });

        this.diamondAdd.addEventListener(
            "click",
            this.processYouTube.bind(this, this.diamondURL.value.trim(), "")
        );
    }

    private addDialogListeners() {
        this.dialogPhoto.addEventListener(
            "click",
            this.processPhoto.bind(this, false, undefined)
        );
        this.dialogCamera.addEventListener(
            "click",
            this.processPhoto.bind(this, true, undefined)
        );

        this.dialogVideo.addEventListener(
            "click",
            this.processVideo.bind(this, false, undefined)
        );
        this.dialogCamcorder.addEventListener(
            "click",
            this.processVideo.bind(this, true, undefined)
        );

        this.dialogAudio.addEventListener(
            "click",
            this.processAudio.bind(this, false, undefined)
            // isIOS
            //     ? this.processVideo.bind(this, false, undefined)
            //     : this.processAudio.bind(this, false, undefined)
        );
        this.dialogMicrophone.addEventListener(
            "click",
            this.processAudio.bind(this, true, undefined)
            // isIOS
            //     ? this.processVideo.bind(this, true, undefined)
            //     : this.processAudio.bind(this, true, undefined)
        );

        this.dialogAiPicture.addEventListener("click", () =>
            alert("Create a personalized photo with AI! (coming soon)")
        );
        this.dialogAiShort.addEventListener("click", () =>
            alert("Create a personalized video with AI! (coming soon)")
        );
        this.dialogAiSong.addEventListener("click", () =>
            alert("Create a personalized song with AI! (coming soon)")
        );

        this.dialogCancel.addEventListener("click", () => {}); //TODO: cancel upload
        this.dialogClose.addEventListener("click", () => this.dialog.close());
    }

    private toggleLoading(isShow: boolean) {
        const progress = this.querySelector(
            "#hb-ship-dialog-progress-container"
        ) as HTMLElement;
        const buttons = this.querySelector(
            "#hb-ship-dialog-buttons-container"
        ) as HTMLElement;

        if (isShow) {
            progress.classList.remove("hidden");
            buttons.classList.add("hidden");
            this.dialogClose.classList.add("hidden");
            this.dialogCancel.classList.remove("hidden");
        } else {
            progress.classList.add("hidden");
            buttons.classList.remove("hidden");
            this.dialogClose.classList.remove("hidden");
            this.dialogCancel.classList.add("hidden");
        }
    }

    // possible to have same name across different file formats; else will file will be replaced
    private isValidName(name: string) {
        return !this.trove.some((jewelry) => jewelry.n === name);
    }

    private async processPhoto(isCapture: boolean, retry?: File) {
        let photo =
            retry ||
            (await pickFile({
                accept: "image/*",
                capture: isCapture ? "camera" : undefined
            }));
        if (photo) {
            const name = prompt(
                retry
                    ? this.errorMessage
                    : "What title would you like to assign to this Diamond Photo?"
            );
            if (name) {
                if (this.isValidName(name)) {
                    this.toggleLoading(true);
                    try {
                        const fileName = name + "." + photo.type.split("/")[1];
                        photo = await this.media.createPhotoFromFile(photo);
                        const ephoto = await this.crypto.encryptFile(photo);
                        await this.media.saveFileToOPFS(ephoto, {
                            name: fileName,
                            folderPath: "emedia/photos",
                            onProgress: (percent) => {
                                this.dialogProgress.style.width = percent + "%";
                                this.dialogProgress.textContent = `Obfuscating Photo: ${percent}%`;
                            }
                        });
                        await this.media.saveFileToOPFS(photo, {
                            name: fileName,
                            folderPath: "media/photos", // Supports nested folders
                            onProgress: (percent) => {
                                this.dialogProgress.style.width = percent + "%";
                                this.dialogProgress.textContent = `Saving Photo: ${percent}%`;
                            }
                        });
                        if (this.heartbank.user?.phoneNumber) {
                            const e = await this.media.storeFile(
                                fileName,
                                ephoto,
                                (percent) => {
                                    this.dialogProgress.style.width =
                                        percent + "%";
                                    this.dialogProgress.textContent = `Encrypting Photo: ${percent}%`;
                                }
                            );
                            const l = await this.media.storeFile(
                                fileName,
                                photo,
                                (percent) => {
                                    this.dialogProgress.style.width =
                                        percent + "%";
                                    this.dialogProgress.textContent = `Uploading Photo: ${percent}%`;
                                }
                            );
                            this.trove.push({
                                n: fileName,
                                s: "p",
                                d: "media/photos",
                                f: "emedia/photos",
                                l,
                                e
                            });
                        } else {
                            this.trove.push({
                                n: fileName,
                                s: "p",
                                d: "media/photos",
                                f: "emedia/photos"
                            });
                        }
                        localStorage.setItem(
                            "trove",
                            JSON.stringify(this.trove)
                        );
                        await this.renderDiamonds();
                        this.dialog.close();
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        this.toggleLoading(false);
                    }
                } else this.processPhoto(isCapture, photo);
            }
        }
    }

    private async processVideo(isCapture: boolean, retry?: File) {
        let video =
            retry ||
            (await pickFile({
                accept: "video/*",
                capture: isCapture ? "camcorder" : undefined
            }));
        if (video) {
            try {
                const result = await this.media.validateVideoFile(video);
                if (result.isValid) {
                    const name = prompt(
                        retry
                            ? this.errorMessage
                            : "What title would you like to assign to this Diamond Video?"
                    );
                    if (name) {
                        if (this.isValidName(name)) {
                            this.toggleLoading(true);
                            const fileName =
                                name + "." + video.type.split("/")[1];
                            const evideo = await this.crypto.encryptFile(video);
                            await this.media.saveFileToOPFS(evideo, {
                                name: fileName,
                                folderPath: "emedia/videos",
                                onProgress: (percent) => {
                                    this.dialogProgress.style.width =
                                        percent + "%";
                                    this.dialogProgress.textContent = `Obfuscating Video: ${percent}%`;
                                }
                            });
                            await this.media.saveFileToOPFS(video, {
                                name: fileName,
                                folderPath: "media/videos",
                                onProgress: (percent) => {
                                    this.dialogProgress.style.width =
                                        percent + "%";
                                    this.dialogProgress.textContent = `Saving Video: ${percent}%`;
                                }
                            });
                            if (this.heartbank.user?.phoneNumber) {
                                const e = await this.media.storeFile(
                                    fileName,
                                    evideo,
                                    (percent) => {
                                        this.dialogProgress.style.width =
                                            percent + "%";
                                        this.dialogProgress.textContent = `Encrypting Video: ${percent}%`;
                                    }
                                );
                                const l = await this.media.storeFile(
                                    fileName,
                                    video,
                                    (percent) => {
                                        this.dialogProgress.style.width =
                                            percent + "%";
                                        this.dialogProgress.textContent = `Uploading Video: ${percent}%`;
                                    }
                                );
                                this.trove.push({
                                    n: fileName,
                                    s: "v",
                                    d: "media/videos",
                                    f: "emedia/videos",
                                    l,
                                    e
                                });
                            } else {
                                this.trove.push({
                                    n: fileName,
                                    s: "v",
                                    d: "media/videos",
                                    f: "emedia/videos"
                                });
                            }
                            localStorage.setItem(
                                "trove",
                                JSON.stringify(this.trove)
                            );
                            await this.renderDiamonds();
                            this.dialog.close();
                            this.toggleLoading(false);
                        } else this.processVideo(isCapture, video);
                    }
                } else alert(result.errorMessage);
            } catch (error: any) {
                alert(error.message);
            }
        }
    }

    private async processAudio(isCapture: boolean, retry?: File) {
        let audio =
            retry ||
            (await pickFile({
                accept: "audio/*", // mp4 is selectable but error
                capture: isCapture ? "microphone" : undefined
            }));
        if (audio) {
            try {
                if (await this.media.isAudioValid(audio)) {
                    const name = prompt(
                        retry
                            ? this.errorMessage
                            : "What title would you like to assign to this Diamond Song?"
                    );
                    if (name) {
                        if (this.isValidName(name)) {
                            this.toggleLoading(true);
                            const extension = audio.type.split("/")[1];
                            const fileName =
                                name +
                                "." +
                                (extension === "mpeg" ? "mp3" : extension);
                            const eaudio = await this.crypto.encryptFile(audio);
                            await this.media.saveFileToOPFS(eaudio, {
                                name: fileName,
                                folderPath: "emedia/audios",
                                onProgress: (percent) => {
                                    this.dialogProgress.style.width =
                                        percent + "%";
                                    this.dialogProgress.textContent = `Obfuscating Song: ${percent}%`;
                                }
                            });
                            await this.media.saveFileToOPFS(audio, {
                                name: fileName,
                                folderPath: "media/audios",
                                onProgress: (percent) => {
                                    this.dialogProgress.style.width =
                                        percent + "%";
                                    this.dialogProgress.textContent = `Saving Song: ${percent}%`;
                                }
                            });
                            if (this.heartbank.user?.phoneNumber) {
                                const e = await this.media.storeFile(
                                    fileName,
                                    eaudio,
                                    (percent) => {
                                        this.dialogProgress.style.width =
                                            percent + "%";
                                        this.dialogProgress.textContent = `Encrypting Song: ${percent}%`;
                                    }
                                );
                                const l = await this.media.storeFile(
                                    fileName,
                                    audio,
                                    (percent) => {
                                        this.dialogProgress.style.width =
                                            percent + "%";
                                        this.dialogProgress.textContent = `Uploading Song: ${percent}%`;
                                    }
                                );
                                this.trove.push({
                                    n: fileName,
                                    s: "a",
                                    d: "media/audios",
                                    f: "emedia/audios",
                                    l,
                                    e
                                });
                            } else {
                                this.trove.push({
                                    n: fileName,
                                    s: "a",
                                    d: "media/audios",
                                    f: "emedia/audios"
                                });
                            }
                            localStorage.setItem(
                                "trove",
                                JSON.stringify(this.trove)
                            );
                            await this.renderDiamonds();
                            this.toggleLoading(false);
                            this.dialog.close();
                        } else this.processAudio(isCapture, audio);
                    }
                } else alert("Your song needs to be less than 30 minutes.");
            } catch (error: any) {
                alert(error.message);
            }
        }
    }

    private async processYouTube(url: string, error = "") {
        if (url) {
            const youtube = parseYouTubeUrl(url);
            if (youtube) {
                if (
                    this.trove.some(
                        (jewelry: Jewelry) => jewelry.i === youtube.videoId
                    )
                ) {
                    alert("This YouTube video has already been added.");
                } else {
                    const name = prompt(
                        error ||
                            "What title would you like to assign to this Diamond YouTube Video?"
                    );
                    if (name) {
                        if (this.isValidName(name)) {
                            this.trove.push({
                                n: name,
                                s: "y",
                                i: youtube.videoId,
                                l: youtube.shortUrl
                            });
                            localStorage.setItem(
                                "trove",
                                JSON.stringify(this.trove)
                            );
                            this.diamondURL.value = "";
                            this.renderDiamonds();
                        } else this.processYouTube(url, this.errorMessage);
                    }
                }
            } else alert("Please enter a valid YouTube video link.");
        } else {
            const url = await navigator.clipboard.readText(); // should always exist
            this.processYouTube(url); // recursive
        }
    }

    private async renderDiamonds() {
        this.diamonds.innerHTML = "";
        let trove: Jewelry[] = [];
        switch (localStorage.getItem("storage")) {
            case "cloud":
                trove = this.trove.filter((jewelry) => jewelry.l);
                break;
            case "code":
                trove = this.trove.filter((jewelry) => jewelry.l);
                break;
            case "crystal":
                trove = this.trove;
                break;
        }
        await this.renderTrove(trove);
        this.diamonds.classList.toggle(
            "hidden",
            !this.diamonds.hasChildNodes()
        );
        this.diamondTotal.textContent = trove.length.toString();
    }

    private async renderTrove(trove: Jewelry[]) {
        for (const [index, jewelry] of trove.entries()) {
            const li = document.createElement("li");
            li.classList.add(
                jewelry.l && !jewelry.i && !this.heartbank.user
                    ? "opacity-50"
                    : "opacity-100",
                "inline-flex",
                "justify-between",
                "items-center",
                "w-full",
                "px-4",
                "py-2",
                "text-sm",
                "font-medium",
                index === this.trove.length - 1 ? "border-b-0" : "border-b",
                "border-gray-200",
                "rounded-t-lg",
                "hover:bg-gray-100",
                "hover:text-blue-700",
                "focus:z-10",
                "focus:ring-2",
                "focus:ring-blue-700",
                "focus:text-blue-700",
                "dark:border-gray-600",
                "dark:hover:bg-gray-600",
                "dark:hover:text-white",
                "dark:focus:ring-gray-500",
                "dark:focus:text-white"
            );

            const url = jewelry.d
                ? URL.createObjectURL(
                      await this.media.getFileFromOPFS(jewelry.n, jewelry.d)
                  )
                : jewelry.l!;
            //await this.media.fileToDataURL(await this.getFileFromOPFS(jewelry.n, jewelry.d)) // doesn't work on iphone

            const a = document.createElement("a");
            a.href = jewelry.s === "v" && jewelry.l && isIOS ? jewelry.l : url; // video not stored in cloud will not work on iphone
            a.target = "_blank";
            const span = document.createElement("span");
            span.textContent = this.getMediaIcon(jewelry.s);
            span.classList.add("mr-3");
            a.append(span, this.removeExtension(jewelry.n));

            const button = document.createElement("button");
            button.type = "button"; // to prevent auto submit
            button.textContent = "🗑️";
            button.onclick = async () => {
                //button.disabled = true; // not needed bc hidden
                if (jewelry.l && !jewelry.i && !this.heartbank.user)
                    alert(
                        "Please login first in order to delete this Diamond."
                    );
                else if (
                    confirm("Are you sure you want to remove this Diamond?")
                ) {
                    if (jewelry.d)
                        await this.media.deleteFileFromOPFS(
                            jewelry.n,
                            jewelry.d
                        );
                    if (jewelry.f)
                        await this.media.deleteFileFromOPFS(
                            jewelry.n,
                            jewelry.f
                        );
                    if (jewelry.l && !jewelry.i)
                        await this.media.removeFile(jewelry.l);
                    if (jewelry.e) await this.media.removeFile(jewelry.e);
                    this.trove.splice(index, 1);
                    localStorage.setItem("trove", JSON.stringify(this.trove));
                    this.renderDiamonds();
                }
                //button.disabled = false;
            };

            li.append(a, button);
            this.diamonds.appendChild(li);
        }
    }

    private getMediaIcon(type: string): string {
        switch (type) {
            // cloud media service with oEmbed
            case "y": // youtube video
                return "🎞️";
            // LATER: x, fb, vimeo, etc ??

            // local or cloud
            // TROVE // TODO: later create my own oEmbed endpoint ??
            case "v": // video
                return "🎆";
            case "p": // photo
                return "🏞️";
            case "a": // audio
                return "🎶";
            case "d": // 3D model
                return "🥽";
            // other media types: PDF? ebook formats?
            // rich text ? pro no; just take photo of it // OR PDF ?

            default:
                return "📸";
        }
    }

    // TODO: later better regex
    private removeExtension(filename: string): string {
        const lastDot = filename.lastIndexOf(".");
        if (lastDot === -1) return filename; // no extension
        return filename.substring(0, lastDot);
    }

    // deprecated
    // private async renderDiamonds2() {
    //     //console.log(this.media, this.trove);
    //     this.diamonds.innerHTML = "";
    //     switch (localStorage.getItem("storage")) {
    //         case "cloud":
    //             await this.renderTrove2();
    //             break;
    //         case "code":
    //             await this.renderTrove2();
    //             break;
    //         case "crystal":
    //             await this.renderMedia();
    //             await this.renderTrove2();
    //             break;
    //     }
    //     this.diamonds.classList.toggle(
    //         "hidden",
    //         !this.diamonds.hasChildNodes()
    //     );
    //     this.diamondTotal.textContent = (
    //         (await this.media.countFilesInFolder("media")) + this.trove.length
    //     ).toString();
    // }

    // // deprecated
    // private async renderMedia() {
    //     const results = await this.media.getAllFilesInFolder("media");
    //     results.forEach((jewelry: OPFSResult, index: number) => {
    //         const li = document.createElement("li");
    //         li.classList.add(
    //             "inline-flex",
    //             "justify-between",
    //             "items-center",
    //             "w-full",
    //             "px-4",
    //             "py-2",
    //             "text-sm",
    //             "font-medium",
    //             this.trove.length === 0 && index === results.length - 1
    //                 ? "border-b-0"
    //                 : "border-b",
    //             "border-gray-200",
    //             "rounded-t-lg",
    //             "hover:bg-gray-100",
    //             "hover:text-blue-700",
    //             "focus:z-10",
    //             "focus:ring-2",
    //             "focus:ring-blue-700",
    //             "focus:text-blue-700",
    //             "dark:border-gray-600",
    //             "dark:hover:bg-gray-600",
    //             "dark:hover:text-white",
    //             "dark:focus:ring-gray-500",
    //             "dark:focus:text-white"
    //         );

    //         const a = document.createElement("a");
    //         a.href = URL.createObjectURL(jewelry.file);
    //         a.target = "_blank";
    //         const span = document.createElement("span");
    //         span.textContent = this.getMediaIcon(
    //             jewelry.file.type.startsWith("image/") ? "p" : "v"
    //         );
    //         span.classList.add("mr-3");
    //         a.append(span, this.removeExtension(jewelry.file.name));

    //         const button = document.createElement("button");
    //         button.type = "button"; // to prevent auto submit
    //         button.textContent = "🗑️";
    //         button.onclick = async () => {
    //             if (confirm("Are you sure you want to remove this diamond?")) {
    //                 await deleteFileFromOPFS(
    //                     jewelry.file.name,
    //                     jewelry.directory
    //                 );
    //                 this.renderDiamonds2();
    //             }
    //         };

    //         li.append(a, button);
    //         this.diamonds.appendChild(li);
    //     });
    // }

    // // deprecated
    // private renderTrove2() {
    //     this.trove.forEach((jewelry: Jewelry, index: number) => {
    //         const li = document.createElement("li");
    //         li.classList.add(
    //             "inline-flex",
    //             "justify-between",
    //             "items-center",
    //             "w-full",
    //             "px-4",
    //             "py-2",
    //             "text-sm",
    //             "font-medium",
    //             index === this.trove.length - 1 ? "border-b-0" : "border-b",
    //             "border-gray-200",
    //             "rounded-t-lg",
    //             "hover:bg-gray-100",
    //             "hover:text-blue-700",
    //             "focus:z-10",
    //             "focus:ring-2",
    //             "focus:ring-blue-700",
    //             "focus:text-blue-700",
    //             "dark:border-gray-600",
    //             "dark:hover:bg-gray-600",
    //             "dark:hover:text-white",
    //             "dark:focus:ring-gray-500",
    //             "dark:focus:text-white"
    //         );

    //         const a = document.createElement("a");
    //         a.href = jewelry.l!;
    //         a.target = "_blank";
    //         const span = document.createElement("span");
    //         span.textContent = this.getMediaIcon(jewelry.s);
    //         span.classList.add("mr-3");
    //         a.append(span, jewelry.n);

    //         const button = document.createElement("button");
    //         button.type = "button"; // to prevent auto submit
    //         button.textContent = "🗑️";
    //         button.onclick = () => {
    //             if (confirm("Are you sure you want to remove this diamond?")) {
    //                 this.trove.splice(index, 1);
    //                 this.renderDiamonds2();
    //             }
    //         };

    //         li.append(a, button);
    //         this.diamonds.appendChild(li);
    //     });
    // }

    ////

    // TODO: show spinner if await is too long
    // TODO: later show spinner and add await renderCheckin?
    async show() {
        if (this.checkinOrgs.childElementCount === 0) this.renderCheckin(false); // no await bc hidden // need if so that user previous selection is retained // violation when page loads on hb-ship bc need click event
        await this.renderStamp();
        this.trove = JSON.parse(localStorage.getItem("trove") || "[]");
        await this.renderDiamonds(); // needed to show number of diamonds // also bc possible race condition
        await this.crypto.checkSkAndIV();
        this.renderTimeLock();
        loadYouTube(this);
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    render(user: User | null) {
        //render(template(user), this); // weird lit-html bug
        const features = user
            ? JSON.parse(getHero().features || "{}")
            : JSON.parse(localStorage.getItem("features") || "{}");
        const checkin = features.checkin || defaults.checkin;
        this.checkinIcon.style.fill = checkin ? "silver" : "orange";
        //this.checkinLabel.textContent = checkin ? "Private" : "Public";
        this.checkinCheckbox.checked = checkin;
    }

    private renderTimeLock() {
        const storage = localStorage.getItem("storage");
        const date = localStorage.getItem("timelock");

        if (date) {
            const timelock = new Date(parseInt(date));
            this.date.value = timelock.toMMDDYYYY();
            this.time.value = timelock.toHHMM();
            this.clock.classList.remove("fill-gray-500");
            this.clock.classList.add("fill-red-500");
        } else {
            this.date.value = "";
            this.time.value = "15:33";
            this.clock.classList.add("fill-gray-500");
            this.clock.classList.remove("fill-red-500");
        }

        this.timelock.classList.toggle("hidden", storage !== "cloud");
        //console.log(this.date.value, this.time.value);
    }

    private async renderStamp() {
        const storage = localStorage.getItem("storage");
        const stamp = localStorage.getItem("stamp");
        const isStamp =
            stamp &&
            storage === "cloud" &&
            !(await this.stamps.isMinted(stamp));

        this.stamp.classList.toggle("hidden", !isStamp);
        if (isStamp && !this.heartbank.user)
            alert(
                "If you want to link your scanned Silver B-Stamp to this Silver B-Chest, please login first."
            );
    }

    private async renderCheckin(isReset: boolean) {
        //TODO: render crews

        // render orgs
        this.checkinOrgs.innerHTML = "";
        const places = await window.earth.getNearbyPlaces(isReset);
        if (places.length > 0) {
            const place = places[0]; // default location: current city
            const option = document.createElement("option");
            option.value = "0";
            option.dataset.lat = place.lat.toString();
            option.dataset.lng = place.lng.toString();
            option.dataset.address = place.formattedAddress;
            option.dataset.region =
                place.locality === place.region
                    ? place.locality
                    : `${place.locality}, ${place.region}`;
            option.dataset.country = place.country;
            option.text = option.dataset.region;
            this.checkinOrgs.appendChild(option);

            for (const place of places) {
                const option = document.createElement("option");
                option.value = place.id;
                option.dataset.lat = place.lat.toString();
                option.dataset.lng = place.lng.toString();
                option.dataset.address = place.formattedAddress;
                option.dataset.region =
                    place.locality === place.region
                        ? place.locality
                        : `${place.locality}, ${place.region}`;
                option.dataset.country = place.country;
                option.text = place.displayName.truncate2(25);
                this.checkinOrgs.appendChild(option);
            }
        } else {
            const option = document.createElement("option");
            option.value = "0";
            option.dataset.lat = window.earth.longBeach.lat.toString();
            option.dataset.lng = window.earth.longBeach.lng.toString();
            option.dataset.address = window.earth.longBeach.address;
            option.dataset.region = window.earth.longBeach.region;
            option.dataset.country = window.earth.longBeach.country;
            option.text = option.dataset.region;
            this.checkinOrgs.appendChild(option);
        }

        // default checkin location
        this.checkinLocation.textContent =
            this.getKind() === "crew"
                ? this.checkinCrews.options[this.checkinCrews.selectedIndex]
                      .text
                : this.checkinOrgs.options[this.checkinOrgs.selectedIndex].text;
    }

    private renderDiamondBtns(storage?: "cloud" | "code" | "crystal") {
        switch (storage || localStorage.getItem("storage")) {
            case "cloud":
                this.diamondImport.classList.add("hidden");
                this.diamondUpload.classList.remove("hidden");
                break;
            case "code":
                this.diamondImport.classList.add("hidden");
                this.diamondUpload.classList.toggle(
                    "hidden",
                    !this.heartbank.user?.phoneNumber
                );
                break;
            case "crystal":
                this.diamondImport.classList.toggle(
                    "hidden",
                    !!this.heartbank.user?.phoneNumber
                );
                this.diamondUpload.classList.toggle(
                    "hidden",
                    !this.heartbank.user?.phoneNumber
                );
                break;
        }
    }

    private setStorage(storage: "cloud" | "code" | "crystal", event: Event) {
        this.cloud.style.textDecorationLine = "none";
        this.code.style.textDecorationLine = "none";
        this.crystal.style.textDecorationLine = "none";

        const target = event.target as HTMLButtonElement;
        target.style.textDecorationLine = "underline";

        //this.cloudIcon.classList.toggle("hidden", storage !== "cloud");
        //this.codeIcon.classList.toggle("hidden", storage !== "code");
        //this.crystalIcon.classList.toggle("hidden", storage !== "crystal");
        //this.diamondIcon.classList.toggle("hidden", storage === "code");
        //this.scanIcon.classList.toggle("hidden", storage !== "code");
        //if (storage === "code") this.diamond.classList.add("hidden");

        // this.storage.classList.toggle("hidden", storage !== "cloud");
        // this.storage.required = storage === "cloud";
        this.storageFootnote.textContent =
            storage === "cloud"
                ? "This Treasure Chest will be stored inside your HeartBank® Cloud Vault with end-to-end encryption."
                : storage === "code"
                  ? "A backup of this Silver QR Code will be stored on this device for your convenience. You can permanently delete it at anytime inside your HeartBank® Titanium Vault."
                  : "A backup of this Silver 3B Crystal will be stored on this device for your convenience. You can permanently delete it at anytime inside your HeartBank® Titanium Vault.";

        localStorage.setItem("storage", storage);
        this.renderDiamondBtns(storage);
        this.renderStamp();
        this.renderDiamonds();
        this.renderTimeLock();
    }

    private async submit(event: Event) {
        event.preventDefault();
        const storage = localStorage.getItem("storage");
        const stamp = localStorage.getItem("stamp");
        const isStamp =
            stamp &&
            storage === "cloud" &&
            this.heartbank.user &&
            !(await this.stamps.isMinted(stamp));
        if (isStamp)
            alert(
                "This Silver B-Chest will be linked to the Silver B-Stamp you scanned.\n\nTo un-link, tap on the QR Code Icon on the top right corner."
            );

        const location: any = {};
        location.e = +this.checkinCheckbox.checked; // is private
        location.t = window.earth.location?.lat || window.earth.longBeach.lat;
        location.g = window.earth.location?.lng || window.earth.longBeach.lng;
        location.k = this.getKind();
        const place =
            location.k === "crew"
                ? this.checkinCrews.options[this.checkinCrews.selectedIndex]
                : this.checkinOrgs.options[this.checkinOrgs.selectedIndex];
        location.i = place.value; //TODO:
        location.r = place.dataset.region;
        location.c = place.dataset.country;
        location.y = parseFloat(place.dataset.lat!);
        location.x = parseFloat(place.dataset.lng!);
        location.a = place.dataset.address;
        location.n = place.text;

        const media: any = {}; // diamonds
        media.e = +this.diamondCheckbox.checked; // is private
        media.m = [];

        let trove: Jewelry[] = [];
        switch (storage) {
            case "cloud":
                trove = this.trove.filter((jewelry) => jewelry.l);
                break;
            case "code":
                trove = this.trove.filter((jewelry) => jewelry.l);
                break;
            case "crystal":
                trove = this.trove;
                break;
        }

        for (const jewelry of trove) {
            const medium: any = {};
            medium.s = jewelry.s;
            medium.n = jewelry.n; // name or file name // for locating in crystal + infer file type bc may be encrypted

            if (jewelry.i && jewelry.l) {
                // youtube
                medium.i = media.e
                    ? await this.crypto.encryptMessage3(jewelry.i)
                    : jewelry.i;
                medium.l = media.e
                    ? await this.crypto.encryptMessage3(jewelry.l)
                    : jewelry.l;
            } else if (jewelry.l && jewelry.e) {
                // cloud
                medium.l = media.e
                    ? await this.crypto.encryptMessage3(jewelry.e)
                    : jewelry.l;
            } else if (jewelry.d && jewelry.f) {
                // local
                const file = await this.media.getFileFromOPFS(
                    jewelry.n,
                    media.e ? jewelry.f : jewelry.d
                );
                medium.h = await this.crypto.hashFile(file); // hash: to verify file
            }

            media.m.push(medium);
        }

        localStorage.setItem("ship", this.name.value); //this.storageName.value
        localStorage.setItem("location", JSON.stringify(location));
        localStorage.setItem("media", JSON.stringify(media));

        const timelock = this.toLocalDateFromStrings(
            this.date.value,
            this.time.value
        );
        if (storage === "cloud" && timelock && new Date() > timelock)
            alert("Your time lock is not set to a future date!");

        window.location.hash = "#/mint/silver";
    }

    private toLocalDateFromStrings(
        dateStr: string,
        timeStr: string
    ): Date | null {
        // dateStr: "mm/dd/yyyy"
        // timeStr: "HH:MM" (24-hour)

        const dateMatch = dateStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        const timeMatch = timeStr.match(/^(\d{2}):(\d{2})$/);

        if (!dateMatch || !timeMatch) {
            return null;
        }

        const [, mm, dd, yyyy] = dateMatch;
        const [, HH, MM] = timeMatch;

        const month = Number(mm) - 1; // JS months are 0-based
        const day = Number(dd);
        const year = Number(yyyy);
        const hours = Number(HH);
        const minutes = Number(MM);

        if (
            month < 0 ||
            month > 11 ||
            day < 1 ||
            day > 31 ||
            hours < 0 ||
            hours > 23 ||
            minutes < 0 ||
            minutes > 59
        ) {
            return null;
        }

        const date = new Date(year, month, day, hours, minutes, 0, 0);

        // Validate calendar correctness (e.g., 02/30)
        if (
            date.getFullYear() !== year ||
            date.getMonth() !== month ||
            date.getDate() !== day ||
            date.getHours() !== hours ||
            date.getMinutes() !== minutes
        ) {
            return null;
        }

        return date;
    }
}
